import React, { useEffect } from 'react';
import { BarChartComponent } from '../../../../components/charts/BarChartComponent';
import { CardComponent } from '../../CardComponent';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { selectFirstLoadFulfilled } from '../TrendComponent/trendComponentSlice';
import {
  selectChartCategories,
  selectComparisonAPIResponse,
  selectComparisonChartData,
  selectComparisonComponentState,
  selectComparisonHasError,
  selectComparisonLabel,
  selectIsComparisonDataLoading,
  setChartData,
  setHTMLSubtitle,
} from './comparisonComponentSlice';
import { drilldownClickHandler } from './utils';

export function ComparisonComponent() {
  const componentState = useAppSelector(selectComparisonComponentState);
  const apiResponse = useAppSelector(selectComparisonAPIResponse);
  const customer = useAppSelector(selectComparisonLabel);
  const chartData = useAppSelector(selectComparisonChartData);
  const chartCategories = useAppSelector(selectChartCategories);
  const isComparisonLoading = useAppSelector(selectIsComparisonDataLoading);
  const comparisonHasError = useAppSelector(selectComparisonHasError);
  const comparisonLabel = useAppSelector(selectComparisonLabel);
  const hasData = useAppSelector(selectFirstLoadFulfilled);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHTMLSubtitle());
    dispatch(setChartData());
  }, [apiResponse]);

  const isPercent = apiResponse.factor === 100;
  const suffix = isPercent ? '%' : '';

  return (
    <CardComponent
      title={`${comparisonLabel} Comparison`}
      isLoading={isComparisonLoading}
      hasError={comparisonHasError}
    >
      {(!isComparisonLoading || hasData) && (
        <BarChartComponent
          name={apiResponse.statistic}
          title={``}
          categories={chartCategories}
          dataPoints={chartData}
          htmlSubtitle={componentState.chartHTMLSubtitle}
          chartHeight={500}
          click={drilldownClickHandler}
          suffix={suffix}
          tooltipFormatterFunction={function () {
            return this.x + '<br/>' + this.point.name + ': <span>' + this.point.y + suffix + '</span><br/>Surveys: ' + this.point.interviews;
          }}
        />
      )}
    </CardComponent>
  );
}
